export const pieLabels = {
  id: "pieLabels",
  afterDraw(chart) {
    if (
      chart.canvas.id == "my-chart-pie" ||
      chart.canvas.id == "my-chart-pie2"
    ) {
      // console.log(chart);
      // chart.ctx.save();

      const {
        ctx,
        data,
        chartArea: { width, height },
      } = chart;

      const calculateY = (index) => {
        if (chart.canvas.id == "my-chart-pie2" && index == 5) return 2;
        else if (chart.canvas.id == "my-chart-pie2" && index == 6) return 10;
        else if (index == 7) return 20;
        else if (index == 8) return 40;
        else if (index == 9) return 65;
        else if (index == 10) return 50;
        else return 25;
      };

      data.datasets.forEach((dataset, index) => {
        chart.getDatasetMeta(index).data.forEach((datapoint, i) => {
          const { x, y } = datapoint.tooltipPosition();

          const halfwidth =
            chart.canvas.id == "my-chart-pie2" ? width / 2 + 150 : width / 2;
          const halfheight = height / 2;

          const xLine = x >= halfwidth - 15 ? x + 25 : x - 25;
          const yLine = y >= halfheight ? y + 25 : y - calculateY(i);
          const extraLine = x >= halfwidth - 15 ? 25 : -25;

          // line
          ctx.beginPath();
          ctx.moveTo(x, y);
          ctx.lineTo(xLine, yLine);
          ctx.lineTo(xLine + extraLine, yLine);
          ctx.strokeStyle = "#CCC";
          ctx.stroke();

          // console.log(ctx);

          //text
          // const textWidth = ctx.measureText(chart.data.labels[index]).width;
          ctx.font = "16px 'sanuk-bold'";

          var lines = data.labels[i].split("\n");

          //control the position
          const plusFivePx = x >= halfwidth - 15 ? 5 : -5;
          ctx.textAlign = x >= halfwidth - 15 ? "left" : "right";
          ctx.textBaseline = "middle";
          ctx.width = 150;
          ctx.fillStyle =
            chart.canvas.id == "my-chart-pie2"
              ? "rgba(236,22,81, 1)"
              : "rgba(139,197,63, 1)";
          // ctx.fillText(data.labels[i], xLine + extraLine + plusFivePx, yLine);
          for (var iFor = 0; iFor < lines.length; iFor++)
            ctx.fillText(
              lines[iFor],
              xLine + extraLine + plusFivePx,
              iFor == 0 ? yLine - 10 : yLine + 12
            );
        });
      });
    }
  },
};
